const firebaseConfig = {
	apiKey: "AIzaSyA1B68hVtqA_-uDODAwbxfDiLhpzvzg6dQ",
	authDomain: "ema-jhon101.firebaseapp.com",
	projectId: "ema-jhon101",
	storageBucket: "ema-jhon101.appspot.com",
	messagingSenderId: "697679003055",
	appId: "1:697679003055:web:8c9e73da28d711dc50835a",
	measurementId: "G-HG19VCHGYT",
};

export default firebaseConfig;
